import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Desktop, Mobile } from '../../../App';
import { formatVP } from '../../../helpers/helperFunctions';
import { CaptionText, P1 } from '../../../styles/FontStyles';
import { color } from '../../../styles/GlobalStyles';
import { FlexCenter } from '../../../styles/stylesStyled';
import { LevelZero } from '../common/desktop';
import {
  FlexCenterEqual,
  VolumesUser,
  VolumeUserWrap
} from '../MyTeamBackofficeStyled';
import UserComponent from '../UserComponent';

const UserVolume = ({ volumeInfo, tab }) => {
  const { t } = useTranslation('myTeam');

  const { userAsTeamMember, userAsTeamMemberInfo } = useSelector(
    (state) => state.myTeamBackoffice
  );

  const UserMobile = () => {
    return (
      <VolumesUser>
        <UserComponent user={userAsTeamMember} />

        <FlexCenterEqual>
          <div>
            <CaptionText
              mb='4'
              style={{ width: '100%' }}
              color={color.colors.neutral500}>
              {t('left_team')}
            </CaptionText>

            <P1 color={color.colors.neutral900}>
              {formatVP(volumeInfo?.leftLegTotalVolume)}
            </P1>
            {/* <h3>
              <span>+{volumeInfo.currentVolumeInfo.leftLegVolumeChange} </span>
              this week
            </h3> */}
          </div>
          <div>
            <CaptionText
              mb='4'
              style={{ width: '100%' }}
              color={color.colors.neutral500}>
              {t('right_team')}
            </CaptionText>

            <P1 color={color.colors.neutral900}>
              {formatVP(volumeInfo?.rightLegTotalVolume)}
            </P1>
            {/* <h3>
              <span>+{volumeInfo.currentVolumeInfo.rightLegVolumeChange} </span>
              this week
            </h3> */}
          </div>
        </FlexCenterEqual>
      </VolumesUser>
    );
  };

  return (
    <VolumeUserWrap>
      <Desktop>
        <LevelZero
          teamMember={userAsTeamMember}
          teamMemberInfo={userAsTeamMemberInfo}
          tab={tab}
        />
      </Desktop>
      <Mobile style={{ width: '100%' }}>
        <FlexCenter style={{ flexDirection: 'column' }}>
          <UserMobile />
        </FlexCenter>
      </Mobile>
    </VolumeUserWrap>
  );
};

export default UserVolume;
